import { defineComponent as _defineComponent } from 'vue'
import { NewBuyBoxView } from '@/stores/user.store';
import { useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxTypeSwitcher',
  props: {
    additionalContexts: null,
    buyBoxType: null
  },
  emits: ["buyBoxTypeSwitched"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'buyBoxTypeSwitched', payload: { buyBoxType: NewBuyBoxView }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	additionalContexts: SnowplowContext[];
	buyBoxType?: NewBuyBoxView;
};





const {
	newBuyboxTooltipAcknowledged,
	setNewBuyboxTooltipAcknowledged,
	newBuyboxView,
	setNewBuyboxView,
	isUserFirstVisit,
} = useUserStore();

const { t } = useI18n();

const buyboxView = computed(() => props.buyBoxType ?? newBuyboxView.value);

const handleListClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.LIST });
	} else {
		setNewBuyboxView(NewBuyBoxView.LIST);
	}
	trackToggleEvent(NewBuyBoxView.LIST);
};

const handleGridClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.GRID });
	} else {
		setNewBuyboxView(NewBuyBoxView.GRID);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.GRID);
};

const trackToggleEvent = (label: NewBuyBoxView) => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_view_clicked', label }, props.additionalContexts);
	// trackTitleDetailRedesignNewBuyBoxExp({
	// 	action: 'click',
	// 	label: 'buybox_view_clicked',
	// });
};

const close = () => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_switch_acknowledged' }, props.additionalContexts);
	// trackTitleDetailRedesignNewBuyBoxExp({ action: 'click', label: 'buybox_switch_acknowledged' });
	setNewBuyboxTooltipAcknowledged();
};

return { __sfc: true,props, emit, newBuyboxTooltipAcknowledged, setNewBuyboxTooltipAcknowledged, newBuyboxView, setNewBuyboxView, isUserFirstVisit, t, buyboxView, handleListClicked, handleGridClicked, trackToggleEvent, close }
}

})